module.exports = __webpack_public_path__ + "media/assets/icons/cil_chat-bubble-401201d606093f1575277fa2f749c4b4.svg";